import { ItemIdentifiersFilterDialog } from '@retail/products/components';
import { ItemIdentifiers, ItemIdentifiersFilter } from '@retail/products/utils';

interface FetchItemsResult {
  data?: { items: ItemIdentifiers[] };
  isLoading: boolean;
}

interface Props {
  assortmentId: number;
  /** Fetches the whole assortment unfiltered, so the uploaded identifiers are matched against every item */
  useFetchItems: (props: { assortmentId: number; suspense: false }) => FetchItemsResult;
  onApply: (filter: ItemIdentifiersFilter) => void;
  onClose: () => void;
}

export function AssortmentItemIdentifiersFilterDialog({
  assortmentId,
  useFetchItems,
  onApply,
  onClose,
}: Props) {
  const { data, isLoading } = useFetchItems({ assortmentId, suspense: false });

  return (
    <ItemIdentifiersFilterDialog
      items={data?.items}
      isLoadingItems={isLoading}
      onApply={onApply}
      onClose={onClose}
    />
  );
}
